<template>
    <div class="flex flex-col gap-3">
      <div class="inline-flex justify-between">
        <label class="text-lg md:text-[28px] font-semibold">Recent Searches</label>
        <UButton variant="link" size="sm" label="Clear all" :ui="{ base: 'normal-case w-auto' }" @click="clearAll" v-if="recentSearches.length"/>
      </div>
      <div class="flex flex-wrap gap-3" v-if="recentSearches.length">
        <UBadge color="gray" variant="solid" size="lg" class="cursor-pointer" :icon="item.icon" :label="item.label" v-for="(item, index) in recentSearches" :key="index" @click="handleNavigation(item)"></UBadge>
      </div>
      <div v-else>
        <p class="text-xs text-gray-500">Start searching for any stores or products</p>
      </div>
    </div>
  </template>
  
  <script setup>
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventCTANames, EventParameter } from '~/google_analytics/events.enum';

  const emit = defineEmits(['selected']);
  
  const recentSearches = ref([]);
  
  const { gtag } = useGtag();
  const auth = useAuth();
    const isAuthenticated = auth && auth.access_token;
    const userData = isAuthenticated ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    } : {
      user_name: null,
      user_phone: null,
      user_email: null
    };
  
  const updateRecentSearches = () => {
    const searches = JSON.parse(localStorage.getItem('searches') || '[]')
      .slice(0, 5)
      .map(item => ({
        icon: 'i-ph-clock-counter-clockwise',
        label: item.name,
      }));
    recentSearches.value = searches;
  };
  updateRecentSearches();
  
  const handleNavigation = async (item) => {

    GoogleAnalytics.cta({
      [EventParameter.CTA_NAME]: EventCTANames.RECENT_SEARCHES,
      [EventParameter.SEARCH_QUERY]: item.label,
    });

    emit('selected', item.label);
  }
  
  const clearAll = () => {

    GoogleAnalytics.cta({
      [EventParameter.CTA_NAME]: EventCTANames.CLEAR_ALL,
    });

    localStorage.removeItem('searches');
    updateRecentSearches();
  }
  </script>